import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { persistStore } from 'redux-persist'
import { createBrowserHistory } from 'history'
import { authMiddleware, cookiesConsentMiddleware } from 'shared/store/user'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createRootReducer } from 'shared/store/reducers'
import { analyticsMiddleware } from 'shared/store/metadata'
import { ws } from 'shared/store/ws'
//$FlowFixMe
import webStorage from 'redux-persist/lib/storage'

const storage = JSON.parse(localStorage.getItem('persist:userState') || '{}')
const wsHeaders = ws.defaults.headers
wsHeaders['Authorization'] =
    storage && storage.token ? JSON.parse(storage.token) : undefined
wsHeaders['x-platform'] = 'WEB'
wsHeaders['x-application'] = 'WEBSITE'
wsHeaders['X-Frame-Options'] = 'SAMEORIGIN'

const composeEnhancers =
    process.env.REACT_APP_ENV !== 'prd'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
        : compose

const history = createBrowserHistory()

const rootReducer = createRootReducer(webStorage)

const configureStore = (initialState: any) => {
    const reducer = combineReducers({
        ...rootReducer,
        router: connectRouter(history)
    })
    const store = createStore(
        reducer,
        initialState,
        composeEnhancers(
            applyMiddleware(
                thunkMiddleware,
                routerMiddleware(history),
                analyticsMiddleware,
                cookiesConsentMiddleware,
                authMiddleware
            )
        )
    )

    const persistor = persistStore(store)

    return { store, persistor }
}

export { history, configureStore }
